import { render } from "./ModelPerformance.vue?vue&type=template&id=1e702d30&scoped=true"
import script from "./ModelPerformance.vue?vue&type=script&lang=js"
export * from "./ModelPerformance.vue?vue&type=script&lang=js"

import "./ModelPerformance.vue?vue&type=style&index=0&id=1e702d30&scoped=true&lang=css"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e702d30"]])

export default __exports__